import api from './api';

export const getCoresList = async () => {
  try {
    const { data } = await api.get('cor/list');
    return data;
  } catch (error) {
    return { error };
  }
};
